import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';
import { LIVE_VIEW_FILTER_STATUSES } from '../../../constants';

const ProjectLiveViewStatusChip = ({ value }) => {
  const { t } = useContext(ConfigContext);

  return <>{value.map((flag) => t(LIVE_VIEW_FILTER_STATUSES[flag]?.labelSlug)).join(', ')}</>;
};

export default ProjectLiveViewStatusChip;
